module.exports = __webpack_public_path__ + "img/icon-flat.177a8b6b.svg";